export const WebUrl =
  /^(http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!\\$&'\\(\\)\\*\\+,;=.]+$/;
export const BaleJoinLink =
  /^(?:(?:(?:https?|bale|ble):\/\/)?ble\.ir\/|bale:\/\/)join\/(.+)$/;
export const NumberOnly = /^[\d۰-۹]*$/;
export const NotAllDigitsEnglish = /^[A-Za-z0-9۱-۹ ]*$/;
export const ContainsEnglish = /[A-Za-z]/;
export const WrongBaleLink = /https?:\/\/bale\.ir|bale\.ir/g;
